import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "mt-6" }
const _hoisted_2 = { class: "bg-white mt-6 p-6 px-4 rounded border" }
const _hoisted_3 = { class: "grid grid-cols-1 gap-3 md:grid-cols-2" }
const _hoisted_4 = { class: "flex items-center justify-end mt-3" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-file-excel mr-2" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_page_title = _resolveComponent("page-title")!
  const _component_the_input = _resolveComponent("the-input")!
  const _component_the_button = _resolveComponent("the-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_page_title, { title: "Экспорт транскриптов" }),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_the_input, {
          type: "date",
          value: _ctx.state.start_date,
          "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.state.start_date) = $event)),
          "is-invalid": _ctx.state_form$.start_date.$error,
          "validation-errors": _ctx.state_form$.start_date.$errors,
          placeholder: "Дата от"
        }, null, 8, ["value", "is-invalid", "validation-errors"]),
        _createVNode(_component_the_input, {
          type: "date",
          value: _ctx.state.end_date,
          "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.state.end_date) = $event)),
          "is-invalid": _ctx.state_form$.end_date.$error,
          "validation-errors": _ctx.state_form$.end_date.$errors,
          placeholder: "Дата до"
        }, null, 8, ["value", "is-invalid", "validation-errors"])
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_the_button, {
          loading: _ctx.state.is_loading,
          class: "primary small",
          onClick: _ctx.exportTranscripts
        }, {
          default: _withCtx(() => [
            _hoisted_5,
            _createTextVNode(" Экспортировать ")
          ]),
          _: 1
        }, 8, ["loading", "onClick"])
      ])
    ])
  ]))
}